const apiUrl = window.location.protocol === 'http:' 
	? 'http://localhost:5000/bliss-retreat/us-central1/'
	:'https://us-central1-bliss-retreat.cloudfunctions.net/'
export default apiUrl